export default __webpack_public_path__ + "static/media/DSC_0506.fe21ceb4.webp";